import { ColumnType } from '../../../types';
import { ChartSettingsV2MenuItems, } from '../chart-settings-v2-schema.types';
import { createAggregationDropdown, createAllDataLabelVisibilityCheckboxForHeatmapChart, createAxisGridlinesFormatter, createAxisGridlinesVisibilityCheckbox, createAxisHorizontalPositionControl, createAxisIntervalsFormatter, createAxisIntervalsVisibilityCheckbox, createAxisLinesAccordionItem, createAxisNameAccordionItem, createAxisNameFontFormatter, createAxisNameTextInput, createAxisNameVisibilityCheckbox, createAxisValueLabelFontFormatter, createAxisValueLabelMaxCharactersInput, createAxisValueLabelNumberFormatter, createAxisValueLabelVisibilityCheckbox, createAxisVisibilityCheckbox, createBackgroundAccordionItem, createChartBackgroundColorFormatter, createChartColumnNumberFormatter, createChartSortFormat, createColumnDataColorsPicker, createColumnNameTextInput, createDataLabelAlignmentDropdown, createDataLabelBackgroundFormatter, createDataLabelFilterDropdown, createDataLabelFontFormatter, createDataLabelMaxLengthInput, createDataLabelNumericFilter, createGradientColorPicker, createIntervalsAccordionItem, createMaxDataPointsInput, createPlotAreaBackgroundColorFormatter, createShowNullAsZeroCheckbox, createTimeBucketDropdown, createTooltipBackgroundFormatter, createTooltipContentFormatter, createTooltipFieldLabelFormatter, createTooltipFontFormatter, createTooltipVisibilityCheckbox, createValueLabelAccordionItem, createYAxisNumberRangeInput, } from '../schema-composer-utils/common-elements';
import { shouldHideDataLabelsAccordion, shouldHideTooltipSettings, } from '../schema-composer-utils/common-rules';
import { createAccordion, createAccordionItem, createBackgroundImageEditor, createSection, } from '../schema-composer-utils/elements';
const columnSettings = [
    {
        type: ColumnType.Attribute,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                properties: {
                                    header: '',
                                    isExpanded: true,
                                    noPadding: true,
                                    variant: 'sideNav',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createChartColumnNumberFormatter(),
                                    createColumnDataColorsPicker(),
                                    createChartSortFormat(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Measure,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createChartColumnNumberFormatter(),
                                    createShowNullAsZeroCheckbox(),
                                    createAggregationDropdown(),
                                    createGradientColorPicker(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Date,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        properties: {
                            spacing: 'ignore',
                        },
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createTimeBucketDropdown(),
                                    createColumnDataColorsPicker(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
];
const dataLabelSettings = [
    createSection({
        isHiddenCallback: shouldHideDataLabelsAccordion,
        children: [
            createAllDataLabelVisibilityCheckboxForHeatmapChart(),
            createDataLabelFilterDropdown(),
            createDataLabelNumericFilter(),
            createDataLabelFontFormatter(),
            createDataLabelMaxLengthInput(),
            createDataLabelAlignmentDropdown(),
            createDataLabelBackgroundFormatter(),
        ],
    }),
];
const tooltipSettings = [
    createSection({
        children: [
            createTooltipVisibilityCheckbox(),
            createTooltipContentFormatter(),
        ],
    }),
    createSection({
        isAdvanced: true,
        children: [
            createTooltipBackgroundFormatter(),
            createTooltipFieldLabelFormatter(),
            createTooltipFontFormatter(),
        ],
        isHiddenCallback: shouldHideTooltipSettings,
    }),
];
const displaySettings = [
    createSection({
        children: [createMaxDataPointsInput()],
    }),
    createSection({
        isAdvanced: true,
        children: [
            createAccordion({
                children: [
                    createBackgroundAccordionItem([
                        createChartBackgroundColorFormatter(),
                        createPlotAreaBackgroundColorFormatter(),
                        createBackgroundImageEditor(),
                    ]),
                ],
            }),
        ],
    }),
];
const axisSettings = [
    {
        type: ColumnType.Attribute,
        settings: [
            createSection({
                children: [
                    createAxisVisibilityCheckbox(),
                    createAxisHorizontalPositionControl(),
                ],
            }),
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createAxisNameAccordionItem([
                                createAxisNameVisibilityCheckbox(),
                                createAxisNameTextInput(),
                                createAxisNameFontFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createValueLabelAccordionItem([
                                createAxisValueLabelVisibilityCheckbox(),
                                createAxisValueLabelNumberFormatter(),
                                createAxisValueLabelFontFormatter(),
                                createAxisValueLabelMaxCharactersInput(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                isAdvanced: true,
                children: [
                    createAccordion({
                        children: [
                            createAxisLinesAccordionItem([
                                createAxisGridlinesVisibilityCheckbox(),
                                createAxisGridlinesFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                isAdvanced: true,
                children: [
                    createAccordion({
                        children: [
                            createIntervalsAccordionItem([
                                createAxisIntervalsVisibilityCheckbox(),
                                createAxisIntervalsFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Measure,
        settings: [
            createSection({
                children: [
                    createAxisVisibilityCheckbox(),
                    createYAxisNumberRangeInput(),
                ],
            }),
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createAxisNameAccordionItem([
                                createAxisNameVisibilityCheckbox(),
                                createAxisNameTextInput(),
                                createAxisNameFontFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createValueLabelAccordionItem([
                                createAxisValueLabelVisibilityCheckbox(),
                                createAxisValueLabelNumberFormatter(),
                                createAxisValueLabelFontFormatter(),
                                createAxisValueLabelMaxCharactersInput(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                isAdvanced: true,
                children: [
                    createAccordion({
                        children: [
                            createAxisLinesAccordionItem([
                                createAxisGridlinesVisibilityCheckbox(),
                                createAxisGridlinesFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                isAdvanced: true,
                children: [
                    createAccordion({
                        children: [
                            createIntervalsAccordionItem([
                                createAxisIntervalsVisibilityCheckbox(),
                                createAxisIntervalsFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Date,
        settings: [
            createSection({
                children: [createAxisVisibilityCheckbox()],
            }),
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createAxisNameAccordionItem([
                                createAxisNameVisibilityCheckbox(),
                                createAxisNameTextInput(),
                                createAxisNameFontFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createValueLabelAccordionItem([
                                createAxisValueLabelVisibilityCheckbox(),
                                createAxisValueLabelFontFormatter(),
                                createAxisValueLabelMaxCharactersInput(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                isAdvanced: true,
                children: [
                    createAccordion({
                        children: [
                            createAxisLinesAccordionItem([
                                createAxisGridlinesVisibilityCheckbox(),
                                createAxisGridlinesFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
            createSection({
                isAdvanced: true,
                children: [
                    createAccordion({
                        children: [
                            createIntervalsAccordionItem([
                                createAxisIntervalsVisibilityCheckbox(),
                                createAxisIntervalsFormatter(),
                            ]),
                        ],
                    }),
                ],
            }),
        ],
    },
];
export const heatmapChartSettingsSchema = {
    [ChartSettingsV2MenuItems.COLUMN]: columnSettings,
    [ChartSettingsV2MenuItems.AXIS]: axisSettings,
    [ChartSettingsV2MenuItems.DATA_LABEL]: dataLabelSettings,
    [ChartSettingsV2MenuItems.TOOLTIP]: tooltipSettings,
    [ChartSettingsV2MenuItems.LEGEND]: null,
    [ChartSettingsV2MenuItems.DISPLAY]: displaySettings,
};
//# sourceMappingURL=heatmap-schema.js.map